import React from 'react';
import { MessageSquare, FileSearch, PenTool, Code2, Rocket, CheckCircle } from 'lucide-react';
import Section from '../layout/Section';
import Container from '../layout/Container';

const steps = [
  {
    icon: MessageSquare,
    title: 'Reach Out',
    description: 'Contact us through our website or schedule a free consultation.'
  },
  {
    icon: FileSearch,
    title: 'Consultation',
    description: 'We\'ll discuss your goals and vision for your website.'
  },
  {
    icon: PenTool,
    title: 'Proposal',
    description: 'We\'ll send you a plan with pricing and project details.'
  },
  {
    icon: Code2,
    title: 'Development',
    description: 'We\'ll build your site, keeping you updated every step of the way.'
  },
  {
    icon: Rocket,
    title: 'Launch',
    description: 'Your site goes live with our full support and guidance.'
  },
  {
    icon: CheckCircle,
    title: 'Support',
    description: 'Ongoing maintenance and updates to keep your site running smoothly.'
  }
];

export default function GetStarted() {
  return (
    <Section className="bg-gray-50 dark:bg-gray-800">
      <Container>
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl mb-4">
            Getting Started is Easy
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Our simple process ensures your project runs smoothly from start to finish
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={index}
                className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="flex items-center mb-4">
                  <div className="flex-shrink-0 mr-4">
                    <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-lg flex items-center justify-center">
                      <Icon className="w-6 h-6 text-purple-600 dark:text-purple-400" />
                    </div>
                  </div>
                  <div>
                    <span className="text-sm text-purple-600 dark:text-purple-400">Step {index + 1}</span>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      {step.title}
                    </h3>
                  </div>
                </div>
                <p className="text-gray-600 dark:text-gray-300 ml-14">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}